const ShareTokenTypes = {
  SHARED_REPORT: 0,
}

export { ShareTokenTypes }
